import { Suspense, lazy, useEffect, useState } from "react";

const CookieConsent = lazy(() =>
  import("./CookieConsent").then((m) => ({ default: m.CookieConsent })),
);

/**
 * De cookiebanner is niet kritiek voor de eerste paint: we laden zijn chunk pas
 * wanneer de browser idle is (of na 2s als fallback). Zo concurreert hij niet
 * met de hero-afbeelding en de hydratie.
 */
export function DeferredCookieConsent() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const idle = (
      window as unknown as {
        requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
      }
    ).requestIdleCallback;

    if (idle) {
      const handle = idle(() => setReady(true), { timeout: 2000 });
      return () =>
        (
          window as unknown as { cancelIdleCallback?: (h: number) => void }
        ).cancelIdleCallback?.(handle);
    }

    const timer = window.setTimeout(() => setReady(true), 1200);
    return () => window.clearTimeout(timer);
  }, []);

  if (!ready) return null;

  return (
    <Suspense fallback={null}>
      <CookieConsent />
    </Suspense>
  );
}
